export { default } from "ember-intl/services/intl";
